/*
 * ArtsyWall behaviour tracking, 2026-10-04. Loaded from layout/theme.liquid
 * after window.AW_PAGE = { type, product_id, currency }.
 *
 * Sends aw_* events to GA4 (G-LVW43WJKY4) through the gtag that the Google &
 * YouTube app already runs on the page (it configures GA_ID with
 * send_page_view:false and sends page_view itself), so events share its client
 * ID and session. Events wait in a queue until that tag is configured; after
 * 10 s without it, the script loads gtag.js itself. Every event also
 * goes to Microsoft Clarity as clarity('event', name), plus the tags
 * picker_used, atc_click, searched and scroll_max.
 * Debug: ?aw_debug=1 logs each event to the console (kept for the tab
 * session; ?aw_debug=0 turns it off).
 * Plain ES2017, no dependencies. Every handler is wrapped: it never throws
 * into the page.
 */
(function () {
  'use strict';

  if (window.__awAnalytics) return;
  window.__awAnalytics = true;

  function safe(fn) {
    return function () {
      try {
        return fn.apply(this, arguments);
      } catch (e) {
        return undefined;
      }
    };
  }

  safe(function main() {
    var GA_ID = 'G-LVW43WJKY4';
    var PAGE = window.AW_PAGE || {};
    var PAGE_TYPE = String(PAGE.type || '');
    var PRODUCT_ID = PAGE.product_id != null ? String(PAGE.product_id) : undefined;

    /* ---------- helpers ---------- */

    function clean(s, max) {
      var t = String(s == null ? '' : s).replace(/\s+/g, ' ').trim();
      return max ? t.slice(0, max) : t;
    }

    function closest(el, sel) {
      return el && el.closest ? el.closest(sel) : null;
    }

    function inPath(e, test) {
      var path = e.composedPath ? e.composedPath() : [];
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (n && n.nodeType === 1 && test(n)) return n;
      }
      return null;
    }

    function on(target, type, fn, opts) {
      try {
        target.addEventListener(type, safe(fn), opts);
      } catch (e) {
        /* ignore */
      }
    }

    /* ---------- debug ---------- */

    var DEBUG = false;
    try {
      var dm = /[?&]aw_debug=([01])/.exec(location.search);
      if (dm) {
        if (dm[1] === '1') sessionStorage.setItem('aw_debug', '1');
        else sessionStorage.removeItem('aw_debug');
      }
      DEBUG = sessionStorage.getItem('aw_debug') === '1';
    } catch (e) {
      /* storage blocked */
    }

    /* ---------- Clarity ---------- */

    function clarity() {
      try {
        if (typeof window.clarity === 'function') window.clarity.apply(window, arguments);
      } catch (e) {
        /* ignore */
      }
    }
    var clarityTags = {};
    function clarityTag(key, value) {
      var v = String(value);
      if (clarityTags[key] === v) return;
      clarityTags[key] = v;
      clarity('set', key, v);
    }

    /* ---------- GA4 ---------- */

    var queue = [];
    var gaReady = false;
    var gaBlocked = false;
    var booted = false;

    function analyticsAllowed() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
      } catch (e) {
        /* ignore */
      }
      return true;
    }

    function boot() {
      if (booted) return;
      booted = true;
      if (!analyticsAllowed()) {
        gaBlocked = true;
        queue.length = 0;
        return;
      }
      window.dataLayer = window.dataLayer || [];
      // The Google & YouTube app already runs gtag on the page with GA_ID configured
      // (send_page_view:false; it sends page_view itself). Reuse it; only if it never
      // shows up, load gtag.js ourselves.
      if (!appTagReady()) {
        if (typeof window.gtag !== 'function') {
          window.gtag = function () {
            window.dataLayer.push(arguments);
          };
          window.gtag('js', new Date());
        }
        window.gtag('config', GA_ID, { send_page_view: false });
        var src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
        if (!document.querySelector('script[src^="' + src + '"]')) {
          var s = document.createElement('script');
          s.async = true;
          s.src = src;
          (document.head || document.documentElement).appendChild(s);
        }
      }
      gaReady = true;
      var pending = queue.splice(0);
      for (var i = 0; i < pending.length; i++) window.gtag('event', pending[i][0], pending[i][1]);
    }

    function appTagReady() {
      if (typeof window.gtag !== 'function' || !window.dataLayer) return false;
      for (var i = 0; i < window.dataLayer.length; i++) {
        var a = window.dataLayer[i];
        if (a && a[0] === 'config' && a[1] === GA_ID) return true;
      }
      return false;
    }

    if (appTagReady()) {
      boot();
    } else {
      var waited = 0;
      var poll = setInterval(
        safe(function () {
          waited += 250;
          if (appTagReady() || waited >= 10000) {
            clearInterval(poll);
            boot();
          }
        }),
        250
      );
    }

    function send(name, params, beacon) {
      try {
        var p = { page_type: PAGE_TYPE };
        if (params) {
          for (var k in params) {
            if (Object.prototype.hasOwnProperty.call(params, k)) {
              var v = params[k];
              if (v === undefined || v === null || v === '' || (typeof v === 'number' && isNaN(v))) continue;
              p[k] = v;
            }
          }
        }
        if (DEBUG) console.log('[aw]', name, p);
        clarity('event', name);
        if (gaBlocked) return;
        p.send_to = GA_ID;
        if (gaReady) window.gtag('event', name, p);
        else if (queue.length < 200) queue.push([name, p]);
      } catch (e) {
        /* ignore */
      }
    }

    /* ---------- user interaction clock ---------- */

    var lastInteract = 0;
    var lastTarget = null;
    ['pointerdown', 'touchstart', 'keydown', 'click'].forEach(function (t) {
      on(
        document,
        t,
        function (e) {
          lastInteract = Date.now();
          lastTarget = e.target;
        },
        { capture: true, passive: true }
      );
    });
    function recentUser(ms) {
      return Date.now() - lastInteract < (ms || 1500);
    }

    /* ---------- page counters ---------- */

    var maxScroll = 0;
    var engaged = 0;
    var optionChanges = 0;
    var uiOpens = 0;
    var atcClicked = 0;

    function uiOpen(label) {
      if (!label) return;
      uiOpens++;
      send('aw_ui_open', { ui_label: label });
    }

    /* ---------- product variant helpers ---------- */

    function mainProductInfo() {
      return document.querySelector('product-info[id^="MainProduct"]') || document.querySelector('product-info');
    }

    function readVariant(scope) {
      try {
        var root = scope || mainProductInfo() || document;
        var el = root.querySelector('variant-selects [data-selected-variant]') || root.querySelector('[data-selected-variant]');
        return el ? JSON.parse(el.textContent) : null;
      } catch (e) {
        return null;
      }
    }

    function priceOf(v) {
      return v && typeof v.price === 'number' ? Math.round(v.price) / 100 : undefined;
    }

    function productIdOf(v) {
      if (PRODUCT_ID) return PRODUCT_ID;
      if (v && v.featured_image && v.featured_image.product_id) return String(v.featured_image.product_id);
      return undefined;
    }

    var lastVariant = PAGE_TYPE === 'product' ? readVariant() : null;
    var lastViewedId = lastVariant ? lastVariant.id : null;

    /* ---------- 1. aw_option_select ---------- */

    var pendingOption = null;
    var pendingTimer = null;
    var STEP_NAMES = { material: 'Material', frame: 'Frame', size: 'Size' };

    function flushOption(variant) {
      if (!pendingOption) return;
      clearTimeout(pendingTimer);
      var o = pendingOption;
      pendingOption = null;
      send('aw_option_select', {
        option_name: o.option_name,
        option_value: o.option_value,
        item_id: o.item_id || productIdOf(variant),
        price: priceOf(variant),
      });
    }

    function onOptionChange(t) {
      var name;
      var value;
      var step = closest(t, 'step-picker [data-step]');
      if (step && t.matches('.step-picker__input')) {
        var key = step.getAttribute('data-step');
        name = STEP_NAMES[key] || key;
        var lab = t.labels && t.labels[0];
        if (key === 'frame') value = t.getAttribute('data-label') || t.value;
        else if (key === 'material') value = lab ? clean(lab.textContent) : t.value;
        else value = t.value;
      } else if (closest(t, 'variant-selects')) {
        if (t.tagName === 'SELECT') {
          name = (t.name || '').replace(/^options\[/, '').replace(/\]$/, '');
          value = t.value;
        } else {
          var fs = closest(t, 'fieldset');
          var legend = fs && fs.querySelector('legend');
          name = t.getAttribute('data-option-name') || (legend ? clean(legend.textContent) : '') || t.name;
          value = t.value;
        }
      } else {
        return false;
      }
      optionChanges++;
      clarityTag('picker_used', 'yes');
      if (pendingOption) flushOption(null);
      var pi = closest(t, 'product-info');
      var pidInput = pi && pi.querySelector('input[name="product-id"]');
      pendingOption = {
        option_name: clean(name, 40),
        option_value: clean(value, 100),
        item_id: PRODUCT_ID || (pidInput ? pidInput.value : undefined),
      };
      pendingTimer = setTimeout(
        safe(function () {
          flushOption(null);
        }),
        2500
      );
      return true;
    }

    /* ---------- 2. aw_variant_view ---------- */

    var vvTimer = null;
    function onVariant(v) {
      if (!v) return;
      lastVariant = v;
      if (pendingOption) flushOption(v);
      clearTimeout(vvTimer);
      vvTimer = setTimeout(
        safe(function () {
          if (!recentUser(5000) || v.id === lastViewedId) return;
          lastViewedId = v.id;
          send('aw_variant_view', { variant_title: clean(v.title, 100), price: priceOf(v), item_id: productIdOf(v) });
        }),
        300
      );
    }

    function pubsubName(key, fallback) {
      try {
        /* global PUB_SUB_EVENTS */
        if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS[key]) return PUB_SUB_EVENTS[key];
      } catch (e) {
        /* ignore */
      }
      return fallback;
    }

    function sub(key, fallback, cb) {
      if (typeof window.subscribe !== 'function') return false;
      try {
        window.subscribe(pubsubName(key, fallback), safe(cb));
        return true;
      } catch (e) {
        return false;
      }
    }

    var hasPubsub = sub('variantChange', 'variant-change', function (msg) {
      var d = msg && msg.data;
      if (d && d.variant) onVariant(d.variant);
    });

    if (!hasPubsub && PAGE_TYPE === 'product') {
      var lastParam = new URLSearchParams(location.search).get('variant');
      setInterval(
        safe(function () {
          var p = new URLSearchParams(location.search).get('variant');
          if (p && p !== lastParam) {
            lastParam = p;
            var v = readVariant();
            if (v && String(v.id) === p) onVariant(v);
            else if (pendingOption) flushOption(null);
          }
        }),
        500
      );
    }

    /* ---------- 7. aw_atc_click, aw_cart_error ---------- */

    var lastCartError = { text: '', at: 0 };
    var cartErrors = 0;
    function cartError(msg) {
      var text = clean(msg, 100);
      if (!text || cartErrors >= 5) return;
      if (text === lastCartError.text && Date.now() - lastCartError.at < 3000) return;
      lastCartError = { text: text, at: Date.now() };
      cartErrors++;
      send('aw_cart_error', { error_message: text });
    }

    sub('cartError', 'cart-error', function (d) {
      if (!d) return;
      var msg = typeof d.errors === 'string' ? d.errors : d.message;
      if (!msg && d.errors) msg = JSON.stringify(d.errors);
      cartError(msg);
    });

    if (window.MutationObserver) {
      Array.prototype.forEach.call(document.querySelectorAll('.product-form__error-message-wrapper'), function (w) {
        new MutationObserver(
          safe(function () {
            if (w.hasAttribute('hidden')) return;
            var m = w.querySelector('.product-form__error-message');
            if (m) cartError(m.textContent);
          })
        ).observe(w, { attributes: true, attributeFilter: ['hidden'] });
      });
    }

    on(
      document,
      'submit',
      function (e) {
        var f = e.target;
        if (!f || f.tagName !== 'FORM') return;
        var action = f.getAttribute('action') || '';

        // 9. search form submit
        if (/\/search(\?|$|\/)/.test(action) || /\/search$/.test(action)) {
          var q = f.querySelector('input[name="q"]');
          if (q) searchTyped(q, true);
          return;
        }

        if (!/\/cart\/add/.test(action) || /installment/.test(f.id || '')) return;
        var btn = f.querySelector('[type="submit"]');
        if (btn && btn.getAttribute('aria-disabled') === 'true') return;
        var pi = closest(f, 'product-info');
        var v = readVariant(pi) || lastVariant;
        var pidInput = f.querySelector('input[name="product-id"]');
        var source = 'main';
        if (closest(f, 'quick-add-modal')) source = 'quick_add';
        else if (recentUser(1500) && closest(lastTarget, '[data-sticky-atc-button], sticky-atc')) source = 'sticky';
        atcClicked = 1;
        clarityTag('atc_click', 'yes');
        send(
          'aw_atc_click',
          {
            item_id: (pidInput && pidInput.value) || productIdOf(v),
            variant_title: v ? clean(v.title, 100) : undefined,
            price: priceOf(v),
            ui_label: source,
          },
          true
        );
      },
      true
    );

    /* ---------- 8. cart: product ids for cart lines ---------- */

    var variantProduct = {};
    var cartPromise = null;
    function loadCartMap(force) {
      if (cartPromise && !force) return cartPromise;
      if (!window.fetch) return Promise.resolve();
      cartPromise = fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (c) {
          (c.items || []).forEach(function (i) {
            variantProduct[String(i.variant_id)] = String(i.product_id);
          });
        })
        .catch(function () {});
      return cartPromise;
    }
    if (PAGE_TYPE === 'cart') loadCartMap();

    function cartChange(label, row) {
      var vid = null;
      var vEl = row && row.querySelector('[data-quantity-variant-id]');
      if (vEl) vid = vEl.getAttribute('data-quantity-variant-id');
      var rEl = !vid && row && row.querySelector('[data-variant-id]');
      if (rEl) vid = rEl.getAttribute('data-variant-id');
      var done = false;
      var fire = safe(function () {
        if (done) return;
        done = true;
        send('aw_cart_change', { ui_label: label, item_id: vid ? variantProduct[vid] : undefined });
      });
      if (!vid || variantProduct[vid]) return fire();
      setTimeout(fire, 1500);
      loadCartMap().then(fire, fire);
    }

    var CART_SCOPE = 'cart-items, cart-drawer-items, cart-drawer, #main-cart-items';
    var DYNAMIC =
      '.shopify-payment-button, .additional-checkout-buttons, shopify-accelerated-checkout, ' +
      'shopify-accelerated-checkout-cart, [data-shopify="payment-button"], [data-shopify="dynamic-checkout-cart"]';

    var lastDynamic = 0;
    function dynamicCheckout(e) {
      if (Date.now() - lastDynamic < 2000) return;
      lastDynamic = Date.now();
      var shopPay =
        e &&
        inPath(e, function (n) {
          var s = (n.tagName + ' ' + (typeof n.className === 'string' ? n.className : '') + ' ' + (n.getAttribute('aria-label') || '')).toLowerCase();
          return /shop[-_ ]?pay/.test(s);
        });
      send('aw_checkout_click', { ui_label: shopPay ? 'shop_pay' : 'dynamic_checkout' }, true);
    }

    // Wallet buttons in iframes: the click never reaches this document, but the window blurs.
    on(window, 'blur', function () {
      setTimeout(
        safe(function () {
          var ae = document.activeElement;
          if (ae && closest(ae, DYNAMIC)) dynamicCheckout(null);
        }),
        0
      );
    });

    /* ---------- 4. aw_gallery ---------- */

    var galleryIdx = {};
    function gallery(idx) {
      var i = parseInt(idx, 10);
      if (!i || galleryIdx[i]) return;
      galleryIdx[i] = 1;
      send('aw_gallery', { ui_value: String(i) });
    }

    on(
      document,
      'slideChanged',
      function (e) {
        var t = e.target;
        if (!t || !/^GalleryViewer/.test(t.id || '')) return;
        if (!recentUser(3000) || !closest(lastTarget, 'media-gallery')) return;
        if (e.detail && e.detail.currentPage) gallery(e.detail.currentPage);
      },
      true
    );

    /* ---------- 6. aw_link_click: area ---------- */

    function linkArea(el) {
      if (closest(el, '.shopify-section-group-header-group, header, sticky-header, header-drawer, .announcement-bar, .utility-bar'))
        return 'header';
      if (closest(el, '.shopify-section-group-footer-group, footer')) return 'footer';
      if (closest(el, '.breadcrumb, .breadcrumbs, [aria-label="Breadcrumb"], [aria-label="breadcrumbs"], .article-template__breadcrumb'))
        return 'breadcrumb';
      if (closest(el, '.product-collection-links')) return 'explore_more';
      if (closest(el, 'product-recommendations, .related-products, .complementary-products')) return 'related';
      if (closest(el, '#product-grid, .product-grid-container, .collection-list, .collection-list-wrapper, .hub-collection'))
        return 'collection_grid';
      return 'main';
    }

    function sameSite(host) {
      var a = String(host || '').replace(/^www\./, '');
      var b = String(location.hostname || '').replace(/^www\./, '');
      return a === b;
    }

    /* ---------- click router: 3, 4, 6, 8 ---------- */

    on(
      document,
      'click',
      function (e) {
        var t = e.target;
        if (!t || t.nodeType !== 1) return;

        // 8. cart quantity and remove
        var qb = closest(t, '.quantity__button');
        if (qb && closest(qb, CART_SCOPE)) {
          cartChange(qb.name === 'plus' ? 'qty_up' : 'qty_down', closest(qb, '.cart-item') || closest(qb, 'quantity-input'));
        }
        var rb = closest(t, 'cart-remove-button');
        if (rb) cartChange('remove', closest(rb, '.cart-item') || rb);

        // 8. checkout buttons
        var cb = closest(t, 'button[name="checkout"], #checkout, #CartDrawer-Checkout');
        if (cb) send('aw_checkout_click', { ui_label: closest(cb, 'cart-drawer') ? 'drawer' : 'cart_page' }, true);
        if (closest(t, DYNAMIC)) dynamicCheckout(e);

        // 3. aw_ui_open from clicks
        if (closest(t, '.step-picker__guide, a[href*="size-guide"]')) uiOpen('size_guide');
        if (closest(t, '.product__modal-opener, .product__media-toggle') && !closest(t, 'quick-add-modal')) uiOpen('zoom');
        var popup = closest(t, '.product-popup-modal__opener');
        if (popup) uiOpen('popup:' + clean(popup.textContent.toLowerCase(), 40));
        if (inPath(e, function (n) {
          return n.tagName === 'SHOPIFY-PAYMENT-TERMS';
        }))
          uiOpen('payment_terms');
        if (closest(t, '#cart-icon-bubble') && document.querySelector('cart-drawer')) {
          uiOpen('cart_drawer');
          loadCartMap(true);
        }

        // 4. gallery thumbnails
        var thumb = closest(t, '[id^="GalleryThumbnails"] [data-target]');
        if (thumb) {
          var pos = thumb.getAttribute('data-media-position');
          if (!pos && thumb.parentNode) pos = Array.prototype.indexOf.call(thumb.parentNode.children, thumb) + 1;
          gallery(pos);
        }

        // 6. internal links
        var a = closest(t, 'a[href]');
        if (a && !closest(a, 'cart-remove-button')) {
          var href = a.getAttribute('href') || '';
          if (href && href.charAt(0) !== '#' && !/^(javascript|mailto|tel|sms):/i.test(href)) {
            var u = new URL(a.href, location.href);
            if (sameSite(u.hostname) && !/^\/cart\/(change|clear)/.test(u.pathname)) {
              var img = a.querySelector('img[alt]');
              var label = clean(a.textContent) || a.getAttribute('aria-label') || (img ? img.getAttribute('alt') : '');
              send(
                'aw_link_click',
                { ui_label: clean(label, 60), link_url: u.pathname, link_area: linkArea(a) },
                true
              );
            }
          }
        }
      },
      true
    );

    // Start the cart lookup early, before the click lands.
    on(
      document,
      'pointerdown',
      function (e) {
        if (closest(e.target, 'cart-drawer')) loadCartMap();
      },
      { capture: true, passive: true }
    );

    /* ---------- 3. aw_ui_open from <details> ---------- */

    function detailsLabel(d) {
      if (d.classList.contains('product__description-more')) return 'read_more';
      if (closest(d, 'details-modal.header__search, .header__search')) return 'search_open';
      if (d.id === 'Details-menu-drawer-container') return 'menu';
      if (closest(d, 'header-drawer')) return null; // submenus inside the open menu drawer
      if (closest(d, 'header-menu, .header__inline-menu')) return 'menu';
      var summary = null;
      for (var i = 0; i < d.children.length; i++) {
        if (d.children[i].tagName === 'SUMMARY') {
          summary = d.children[i];
          break;
        }
      }
      var text = summary ? clean(summary.textContent.toLowerCase(), 40) : '';
      return text ? 'details:' + text : null;
    }

    on(
      document,
      'toggle',
      function (e) {
        var d = e.target;
        if (!d || d.tagName !== 'DETAILS' || !d.open) return;
        if (!recentUser(1500)) return; // skip details opened by markup or script
        uiOpen(detailsLabel(d));
      },
      true
    );

    /* ---------- 9. search ---------- */

    var SEARCH_INPUT = 'input[type="search"], input[name="q"]';
    var sentQueries = {};
    var searchTimer = null;

    function searchQuery(raw) {
      var q = clean(String(raw || '').toLowerCase(), 100);
      if (q.length < 2) return null;
      if (q.indexOf('@') !== -1) return null;
      if ((q.match(/\d/g) || []).length >= 6) return null;
      return q;
    }

    function predictiveCount(input) {
      var ps = closest(input, 'predictive-search');
      var el = ps && ps.querySelector('[data-predictive-search-live-region-count-value]');
      if (!el) return undefined;
      var n = parseInt(el.getAttribute('data-total-results'), 10);
      return isNaN(n) ? undefined : n;
    }

    function searchTyped(input, beacon) {
      clearTimeout(searchTimer);
      var q = searchQuery(input.value);
      if (!q || sentQueries[q]) return;
      sentQueries[q] = 1;
      clarityTag('searched', 'yes');
      send('aw_search_typed', { query: q, results_count: predictiveCount(input) }, beacon);
    }

    function isSearchInput(t) {
      return (
        t &&
        t.matches &&
        t.matches(SEARCH_INPUT) &&
        !!closest(t, 'predictive-search, main-search, form[action*="/search"]')
      );
    }

    on(
      document,
      'input',
      function (e) {
        var t = e.target;
        if (!isSearchInput(t)) return;
        clearTimeout(searchTimer);
        searchTimer = setTimeout(
          safe(function () {
            searchTyped(t, false);
          }),
          1500
        );
      },
      true
    );

    on(
      document,
      'focusout',
      function (e) {
        if (isSearchInput(e.target)) searchTyped(e.target, false);
      },
      true
    );

    function searchPageCount() {
      var el =
        document.getElementById('ProductCountDesktop') ||
        document.getElementById('ProductCount') ||
        document.querySelector('.template-search [role="status"]');
      var text = el ? clean(el.textContent) : '';
      var m = /^([\d,]+)/.exec(text);
      if (m) return parseInt(m[1].replace(/,/g, ''), 10);
      if (/no results/i.test(text) || document.querySelector('.template-search--empty')) return 0;
      return undefined;
    }

    if (PAGE_TYPE === 'search') {
      var pageQ = searchQuery(new URLSearchParams(location.search).get('q'));
      if (pageQ) {
        sentQueries[pageQ] = 1;
        clarityTag('searched', 'yes');
        send('aw_search_results', { query: pageQ, results_count: searchPageCount() });
      }
    }

    /* ---------- 1 and 10. change router: options, filters, sort ---------- */

    function facetName(t) {
      var d = closest(t, 'details');
      var s = d && d.querySelector('.facets__summary-label, .mobile-facets__summary span, summary');
      var name = s ? clean(s.textContent).replace(/\s*\(\d+\)\s*$/, '') : '';
      return clean(name || t.name, 60);
    }

    function facetValue(t) {
      if (/\.gte$/.test(t.name)) return 'min:' + t.value;
      if (/\.lte$/.test(t.name)) return 'max:' + t.value;
      var lab = t.labels && t.labels[0];
      var text = lab ? clean(lab.textContent).replace(/\s*\(\d+\)\s*$/, '') : '';
      return clean(text || t.value, 100);
    }

    on(
      document,
      'change',
      function (e) {
        if (!e.isTrusted) return; // the step picker sets Dawn's hidden inputs by script
        var t = e.target;
        if (!t || !t.matches) return;
        if (onOptionChange(t)) return;
        if (t.name === 'sort_by') {
          send('aw_sort', { ui_value: clean(t.value, 60) });
          return;
        }
        if (/^filter\./.test(t.name || '')) {
          if (t.type === 'checkbox' && !t.checked) return;
          send('aw_filter', { filter_name: facetName(t), filter_value: facetValue(t) });
        }
      },
      true
    );

    /* ---------- 5. aw_seen ---------- */

    var SEEN = [
      ['add_to_cart', 'product-info[id^="MainProduct"] [id^="ProductSubmitButton-"], [id^="ProductSubmitButton-"]'],
      ['frame_picker', 'step-picker [data-step="frame"]'],
      ['description', '.product__description'],
      ['explore_more', '.product-collection-links'],
      ['related_products', 'product-recommendations.related-products, product-recommendations'],
      ['footer', 'footer.footer, footer'],
    ];

    if (window.IntersectionObserver) {
      var seenTimers = new Map();
      var seenLabels = new Map();
      var io = new IntersectionObserver(
        safe(function (entries) {
          entries.forEach(
            safe(function (en) {
              var el = en.target;
              var vh = window.innerHeight || 1;
              var ok =
                en.isIntersecting &&
                en.boundingClientRect.height > 0 &&
                (en.intersectionRatio >= 0.5 || en.intersectionRect.height >= vh * 0.5);
              if (ok && !seenTimers.has(el)) {
                seenTimers.set(
                  el,
                  setTimeout(
                    safe(function () {
                      seenTimers.delete(el);
                      if (document.hidden || el.offsetHeight < 20) return;
                      io.unobserve(el);
                      send('aw_seen', { ui_label: seenLabels.get(el) });
                    }),
                    1000
                  )
                );
              } else if (!ok && seenTimers.has(el)) {
                clearTimeout(seenTimers.get(el));
                seenTimers.delete(el);
              }
            })
          );
        }),
        { threshold: [0, 0.25, 0.5, 0.75, 1] }
      );
      SEEN.forEach(function (s) {
        var el = document.querySelector(s[1]);
        if (el && !seenLabels.has(el)) {
          seenLabels.set(el, s[0]);
          io.observe(el);
        }
      });
    }

    /* ---------- 11. aw_scroll ---------- */

    function scrollPct() {
      var de = document.documentElement;
      var h = Math.max(de.scrollHeight, document.body ? document.body.scrollHeight : 0);
      if (!h) return 0;
      var y = (window.pageYOffset || de.scrollTop || 0) + (window.innerHeight || de.clientHeight || 0);
      return Math.max(0, Math.min(100, Math.round((y / h) * 100)));
    }

    var scrollSent = {};
    var scrollQueued = false;
    maxScroll = scrollPct();
    on(
      window,
      'scroll',
      function () {
        if (scrollQueued) return;
        scrollQueued = true;
        setTimeout(
          safe(function () {
            scrollQueued = false;
            var p = scrollPct();
            if (p > maxScroll) maxScroll = p;
            [25, 50, 75, 100].forEach(function (b) {
              if (scrollSent[b] || maxScroll < (b === 100 ? 98 : b)) return;
              scrollSent[b] = 1;
              send('aw_scroll', { percent: b });
              clarityTag('scroll_max', b);
            });
          }),
          200
        );
      },
      { passive: true }
    );

    /* ---------- 12. aw_time ---------- */

    var TIME_MARKS = { 10: 1, 30: 1, 60: 1, 120: 1, 300: 1 };
    setInterval(
      safe(function () {
        if (document.hidden) return;
        engaged++;
        if (TIME_MARKS[engaged]) send('aw_time', { seconds: engaged });
      }),
      1000
    );

    /* ---------- 13. aw_page_summary ---------- */

    var summarySent = false;
    function summary() {
      if (summarySent) return;
      summarySent = true;
      flushOption(lastVariant);
      send(
        'aw_page_summary',
        {
          max_scroll: maxScroll,
          engaged_seconds: engaged,
          option_changes: optionChanges,
          ui_opens: uiOpens,
          atc_clicked: atcClicked,
        },
        true
      );
    }
    on(window, 'pagehide', summary);
    on(document, 'visibilitychange', function () {
      if (document.visibilityState === 'hidden') summary();
    });

    /* ---------- 14. aw_js_error ---------- */

    var jsErrors = 0;
    function jsError(msg) {
      if (jsErrors >= 3) return;
      var text = clean(msg, 100);
      if (!text) return;
      jsErrors++;
      send('aw_js_error', { error_message: text });
    }
    on(window, 'error', function (e) {
      jsError(e.message || (e.error && e.error.message));
    });
    on(window, 'unhandledrejection', function (e) {
      var r = e.reason;
      jsError(r && r.message ? r.message : typeof r === 'string' ? r : 'unhandled rejection');
    });
  })();
})();
